import { render, staticRenderFns } from "./FaixaEtariaCard.vue?vue&type=template&id=5cfd9d37"
import script from "./FaixaEtariaCard.vue?vue&type=script&lang=js"
export * from "./FaixaEtariaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports